import PostApiBase from "@/modules/post/services/ApiBase"

export default class Api {
    static telegramDelete(postId) {
        return PostApiBase.telegramDelete({
            post_id: postId,
        }).then((resp) => {
            return resp.data
        })
    }

    static siteDelete(postId) {
        return PostApiBase.siteDelete({
            post_id: postId,
        }).then((resp) => {
            return resp.data
        })
    }

    static deleteChain(postId) {
        return PostApiBase.deleteChain({
            post_id: postId,
        }).then((resp) => {
            return resp.data
        })
    }
}
